import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Skeleton } from "../../ui/skeleton";
import { Separator } from "../../ui/separator";
import { Badge } from "../../ui/badge";
import { Calendar } from "../../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../../ui/popover";
import { ArrowLeft, Save, Loader2, Plus, X, CalendarIcon } from "lucide-react";
/* import { supabase } from "@/integrations/supabase/client"; */
import { toast } from "sonner";
import { format, parseISO } from "date-fns";
import { cn } from "../../lib/utils";
import type { CateringSettings } from "../../../hooks/useCateringMenus";


interface SettingProps {
  props: any;
  settings:CateringSettings;
  handleChangeNumber: (name: string, value:number) => void;
  handleChangeText: (name: string, value:string[]) => void;
}

const AdminCateringSettings = ({ props, settings, handleChangeNumber, handleChangeText  }: SettingProps) => {
  /* const [settings, setSettings] = useState<CateringSettings | null>(null); */
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [newTimeSlot, setNewTimeSlot] = useState("");

  useEffect(() => {
    const fetchSettings = async () => {/* 
      try {
        const { data, error } = await supabase
          .from("catering_settings")
          .select("*")
          .limit(1)
          .single();

        if (error) throw error;
        setSettings(data);
      } catch (err) {
        console.error("Failed to fetch settings:", err);
        toast.error("Failed to load settings");
      } finally {
        setLoading(false);
      } */
    };

    fetchSettings();
  }, []);

  const handleSave = async () => {
    if (!settings) return;

    setSaving(true);
    try {
     /*  const { error } = await supabase
        .from("catering_settings")
        .update({
          venue_surcharge_inhouse: settings.venue_surcharge_inhouse,
          venue_surcharge_private: settings.venue_surcharge_private,
          venue_surcharge_external: settings.venue_surcharge_external,
          delivery_fee_base: settings.delivery_fee_base,
          gst_rate: settings.gst_rate,
          pay_now_discount_percent: settings.pay_now_discount_percent,
          min_advance_days: settings.min_advance_days,
          time_slots: settings.time_slots,
          blocked_dates: settings.blocked_dates,
        })
        .eq("id", settings.id);

      if (error) throw error;
      toast.success("Settings saved successfully"); */
    } catch (err) {
      console.error("Failed to save settings:", err);
      toast.error("Failed to save settings");
    } finally {
      setSaving(false);
    }
  };

  const updateField = (field: keyof CateringSettings, value: number) => {
    /* if (settings) {
      setSettings({ ...settings, [field]: value });
    } */
  };

  const addTimeSlot = () => {
    if (!settings || !newTimeSlot.trim()) return;
   const updatedTimeSlots = [
      ...settings.companyCateringTimeSlots,
      newTimeSlot.trim()
    ];
    handleChangeText('companyCateringTimeSlots', updatedTimeSlots);
    setNewTimeSlot(""); 
  };

  const removeTimeSlot = (slot: string) => {
    if (!settings) return;
    handleChangeText('companyCateringTimeSlots', settings.companyCateringTimeSlots.filter(s => s !== slot));
  };

  const addBlockedDate = (date: Date | undefined) => {
    if (!settings || !date) return;
    const dateStr = format(date, "yyyy-MM-dd");
    if (settings.companyCateringBlockedDates.includes(dateStr)) {
      toast.error("Date already blocked");
      return;
    }
    const updatedBlockedDates = [
      ...settings.companyCateringBlockedDates,
      dateStr
    ];
    handleChangeText('companyCateringBlockedDates', updatedBlockedDates.sort());
  };

  const removeBlockedDate = (dateStr: string) => {
    handleChangeText('companyCateringBlockedDates', settings.companyCateringBlockedDates.filter(d => d !== dateStr));
  };
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <main className="flex-1">
        <div className="container max-w-2xl">
         
          {/* <div className="flex items-center justify-between mb-8">
            <Button onClick={handleSave} disabled={saving}>
              {saving ? (
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
              ) : (
                <Save className="h-4 w-4 mr-2" />
              )}
              Save Changes
            </Button>
          </div> */}

          <div className="space-y-6">
            {/* Venue Surcharges */}
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Venue Surcharges</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="grid gap-4">
                <div className="space-y-2">
                    <Label htmlFor="companyCateringOrderNotificationEmail">Order Notification Email</Label>
                    <Input
                      id="companyCateringOrderNotificationEmail"
                      type="text"
                      value={settings.companyCateringOrderNotificationEmail}
                      onChange={(e) => handleChangeNumber("companyCateringOrderNotificationEmail", e.target.value || '')}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="surcharge-inhouse">In-House Dining ($)</Label>
                    <Input
                      id="surcharge-inhouse"
                      type="number"
                      min="0"
                      step="0.01"
                      value={settings.companyCateringVenueSurchargeInhouse}
                      onChange={(e) => handleChangeNumber("companyCateringVenueSurchargeInhouse", parseFloat(e.target.value) || 0)}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="surcharge-private">Private Dining ($)</Label>
                    <Input
                      id="surcharge-private"
                      type="number"
                      min="0"
                      step="0.01"
                      value={settings.companyCateringVenueSurchargePrivate}
                      onChange={(e) => handleChangeNumber("companyCateringVenueSurchargePrivate", parseFloat(e.target.value) || 0)}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="surcharge-external">External Venue ($)</Label>
                    <Input
                      id="surcharge-external"
                      type="number"
                      min="0"
                      step="0.01"
                      value={settings.companyCateringVenueSurchargeExternal}
                      onChange={(e) => handleChangeNumber("companyCateringVenueSurchargeExternal", parseFloat(e.target.value) || 0)}
                    />
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Delivery & Fees */}
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Delivery & Fees</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="delivery-fee">Base Delivery Fee ($)</Label>
                  <Input
                    id="delivery-fee"
                    type="number"
                    min="0"
                    step="0.01"
                    value={settings.companyCateringDeliveryFeeBase}
                    onChange={(e) => handleChangeNumber("companyCateringDeliveryFeeBase", parseFloat(e.target.value) || 0)}
                  />
                  <p className="text-xs text-muted-foreground">Applied to external venue orders</p>
                </div>

                <Separator />
              </CardContent>
            </Card>

            {/* Discounts & Promotions */}
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Discounts</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-2">
                  <Label htmlFor="paynow-discount">Pay Now Discount (%)</Label>
                  <Input
                    id="paynow-discount"
                    type="number"
                    min="0"
                    max="100"
                    step="0.1"
                    value={settings.companyCateringPayNowDiscountPercent}
                    onChange={(e) => handleChangeNumber("companyCateringPayNowDiscountPercent", parseFloat(e.target.value) || 0)}
                  />
                  <p className="text-xs text-muted-foreground">Discount for customers who pay immediately</p>
                </div>
              </CardContent>
            </Card>

            {/* Availability */}
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Availability</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="advance-days">Minimum Advance Days</Label>
                  <Input
                    id="advance-days"
                    type="number"
                    min="1"
                    max="90"
                    value={settings.companyCateringMinAdvanceDays}
                    onChange={(e) => handleChangeNumber("companyCateringMinAdvanceDays", parseInt(e.target.value) || 1)}
                  />
                  <p className="text-xs text-muted-foreground">Minimum days in advance for bookings</p>
                </div>
              </CardContent>
            </Card>

            {/* Time Slots */}
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Event Time Slots</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="flex gap-2">
                  <Input
                    placeholder="e.g. 11:00 AM"
                    value={newTimeSlot}
                    onChange={(e) => setNewTimeSlot(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && addTimeSlot()}
                  />
                  <Button type="button" size="sm" onClick={addTimeSlot}>
                    <Plus className="h-4 w-4 mr-1" /> Add
                  </Button>
                </div>
                <div className="flex flex-wrap gap-2">
                  {settings.companyCateringTimeSlots.map((slot) => (
                    <Badge key={slot} variant="secondary" className="gap-1 text-sm py-1 px-3">
                      {slot}
                      <button onClick={() => removeTimeSlot(slot)} className="ml-1 hover:text-destructive">
                        <X className="h-3 w-3" />
                      </button>
                    </Badge>
                  ))}
                </div>
                {settings.companyCateringTimeSlots.length === 0 && (
                  <p className="text-xs text-muted-foreground">No time slots configured. Default slots will be used.</p>
                )}
              </CardContent>
            </Card>

            {/* Blocked Dates */}
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Blocked Dates</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <Popover>
                  <PopoverTrigger asChild>
                    <Button variant="outline" className="w-full justify-start text-left font-normal text-muted-foreground">
                      <CalendarIcon className="mr-2 h-4 w-4" />
                      Add a blocked date
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0" align="start">
                    <Calendar
                      mode="single"
                      onSelect={addBlockedDate}
                      disabled={(date) => date < new Date() || settings.companyCateringBlockedDates.includes(format(date, "yyyy-MM-dd"))}
                      initialFocus
                      className={cn("p-3 pointer-events-auto")}
                    />
                  </PopoverContent>
                </Popover>
                <div className="flex flex-wrap gap-2">
                  {settings.companyCateringBlockedDates.map((dateStr) => (
                    <Badge key={dateStr} variant="outline" className="gap-1 text-sm py-1 px-3">
                      {format(parseISO(dateStr), "MMM d, yyyy")}
                      <button type="button" onClick={() => removeBlockedDate(dateStr)} className="ml-1 hover:text-destructive">
                        <X className="h-3 w-3" />
                      </button>
                    </Badge>
                  ))}
                </div>
                {settings.companyCateringBlockedDates.length === 0 && (
                  <p className="text-xs text-muted-foreground">No dates are currently blocked.</p>
                )}
                <p className="text-xs text-muted-foreground">Blocked dates will not be available for event bookings.</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
    </div>
  );

}


export default AdminCateringSettings